import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lodging", "golf", "total"]

  recalculate() {
    if (this.totalTarget.dataset.manuallyEdited === "true") return
    const lodging = parseFloat(this.lodgingTarget.value) || 0
    const golf = parseFloat(this.golfTarget.value) || 0
    if (lodging > 0 && golf > 0) {
      this.totalTarget.value = (lodging + golf).toFixed(2)
      this.totalTarget.dataset.autoCalculated = "true"
    } else if (lodging > 0 || golf > 0) {
      this.totalTarget.value = ""
      this.totalTarget.dataset.autoCalculated = ""
    }
  }

  totalEdited() {
    if (this.totalTarget.dataset.autoCalculated === "true") {
      this.totalTarget.dataset.autoCalculated = ""
      return
    }
    this.totalTarget.dataset.manuallyEdited = this.totalTarget.value.length > 0 ? "true" : ""
  }
}
